// src/components/admin/MenuAccionesFila.js
import React from 'react';
import { Dropdown } from 'react-bootstrap';
import '../../style/components/GestionDatosMaestros.css';

/**
 * Menú ⋮ de acciones por fila para las tablas de Datos Maestros. Reemplaza los botones
 * outline (editar/suspender/eliminar) por un único disparador neutro.
 *
 * `acciones`: [{ etiqueta, icono, onClick, peligro?, deshabilitado?, motivo? }]. Las entradas
 * falsy se ignoran, así se puede escribir `condicion && { ... }`. Las de `peligro` van al
 * final, debajo de un divisor y en rojo.
 *
 * El menú usa posicionamiento `fixed` (popper) porque las tablas viven dentro de
 * `.table-responsive` y de `.datos-maestros-table { overflow: hidden }` (y la de Feriados de
 * `.gf-table-wrapper`): con `absolute` el menú de las últimas filas quedaba recortado.
 *
 * Un ítem deshabilitado no recibe eventos de puntero (no mostraría un `title`), por eso el
 * `motivo` se muestra como texto debajo de la etiqueta.
 */
const MenuAccionesFila = ({ acciones, etiqueta = 'Acciones' }) => {
    const visibles = acciones.filter(Boolean);
    const normales = visibles.filter((a) => !a.peligro);
    const peligrosas = visibles.filter((a) => a.peligro);

    const renderItem = (accion) => (
        <Dropdown.Item
            key={accion.etiqueta}
            as="button"
            type="button"
            onClick={accion.onClick}
            disabled={accion.deshabilitado}
            className={`menu-acciones-fila-item${accion.peligro && !accion.deshabilitado ? ' text-danger' : ''}`}
        >
            <span className="d-flex align-items-center gap-2">
                {accion.icono && <i className={`bi ${accion.icono}`} aria-hidden="true"></i>}
                {accion.etiqueta}
            </span>
            {accion.deshabilitado && accion.motivo && (
                <small className="d-block text-muted menu-acciones-fila-motivo">{accion.motivo}</small>
            )}
        </Dropdown.Item>
    );

    return (
        <Dropdown align="end" className="menu-acciones-fila">
            <Dropdown.Toggle variant="link" className="menu-acciones-fila-toggle" aria-label={etiqueta} title={etiqueta}>
                <i className="bi bi-three-dots-vertical" aria-hidden="true"></i>
            </Dropdown.Toggle>
            <Dropdown.Menu popperConfig={{ strategy: 'fixed' }}>
                {normales.map(renderItem)}
                {normales.length > 0 && peligrosas.length > 0 && <Dropdown.Divider />}
                {peligrosas.map(renderItem)}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default MenuAccionesFila;
